import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FieldClaimsModel } from '@app/models/system-settings';

@Injectable({ providedIn: 'root' })
export class FieldClaimsService {
	endpointBase = '/api/field-claims';

	constructor(private readonly http: HttpClient) {}

	public getFieldClaims(): Observable<FieldClaimsModel[]> {
		return this.http.get<FieldClaimsModel[]>(`${this.endpointBase}/list`);
	}
}
